import { paymentSchema, type Payment } from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';

const postResume = (id: string): Promise<unknown> =>
  apiRequest<unknown>(`/payments/${id}/resume`, { method: 'POST' });

export const resumePayment = async (id: string): Promise<Payment> =>
  paymentSchema.parse(await postResume(id));
